// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * ProtectedRoute
 * - Children tabhi render honge jab user logged in ho
 * - 10s ke baad login popup show hota hai
 * - Cancel karne par user blocked rahega
 */
const ProtectedRoute = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [blocked, setBlocked] = useState(true); // initially block content

  useEffect(() => {
    const loggedIn = localStorage.getItem("userLoggedIn") === "true";

    if (loggedIn) {
      setIsLoggedIn(true);
      setBlocked(false);
    } else {
      const timer = setTimeout(() => {
        setShowLogin(true);
      }, 10000); // 10s delay
      return () => clearTimeout(timer);
    }
  }, []);

  // Agar user cancel karta hai popup → content block rahe
  const handleCancel = () => {
    setShowLogin(false);
    setBlocked(true);
  };

  // Agar user login kare → access mile
  const handleLogin = () => {
    localStorage.setItem("userLoggedIn", "true");
    setIsLoggedIn(true);
    setShowLogin(false);
    setBlocked(false);
  };

  // content block condition
  if (blocked) {
    return (
      <>
        {/* Waiting / loading screen */}
        {!showLogin && (
          <div className="flex items-center justify-center h-screen text-gray-600 text-lg">
            <div className="animate-pulse">🔒 Checking access...</div>
          </div>
        )}

        {/* Login Popup */}
        <AnimatePresence>
          {showLogin && !isLoggedIn && (
            <motion.div
              key="backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
              aria-modal="true"
              role="dialog"
            >
              <motion.div
                initial={{ scale: 0.8, opacity: 0, y: -20 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.8, opacity: 0, y: 20 }}
                transition={{ duration: 0.3 }}
                className="bg-white p-8 rounded-2xl w-[400px] shadow-2xl text-center"
              >
                <h2 className="text-2xl font-semibold text-blue-700 mb-4">
                  🔐 Secure Login
                </h2>
                <p className="text-gray-600 mb-6">
                  Please login to access this page.
                </p>

                <div className="flex justify-center gap-4">
                  <button
                    onClick={handleLogin}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-5 py-2 rounded-lg transition"
                  >
                    Login Now
                  </button>
                  <button
                    onClick={handleCancel}
                    className="border border-gray-300 px-5 py-2 rounded-lg text-gray-700 hover:bg-gray-50 transition"
                  >
                    Cancel
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </>
    );
  }

  // agar user logged in → children render
  return children;
};

export default ProtectedRoute;
